//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ReviewStars',
  props: {
    rating: { type: Number, default: 5 },
    count: { type: Number, default: 0 },
    showText: { type: Boolean, default: true },
    showLargeNumber: { type: Boolean, default: false },
    crossSellMode: { type: Boolean, default: false },
    reviewMode: { type: Boolean, default: false },
    headerMode: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    size: { type: String, default: '', validator: str => ['', 'sm', 'md', 'lg', 'xl'].includes(str) }
  }
}
